









































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { TaskStatus, TaskType } from "./types";
import { bus } from "@/pages/transitweb/main";

import { endpoints } from "@/endpoints";

import { isNullOrUndefined } from "util";

@Component({
    components: {},
})
export default class Task extends Vue {
    @Prop() private id!: string;
    @Prop() private execution_id!: string;
    @Prop() private task_type!: TaskType;
    @Prop() private task_name!: string;
    @Prop() private service!: string;
    @Prop() private status!: TaskStatus;
    @Prop() private create_time!: Date;
    @Prop() private start_time!: Date;
    @Prop() private end_time!: Date;
    @Prop() private attempts!: number;
    @Prop() private inputs!: any;
    @Prop() private outputs!: any;

    @Getter("auth/isAllowedSensitiveInfo") isAllowedSensitiveInfo!: boolean;
    @Getter("auth/isAdmin") isAdmin!: boolean;

    TaskStatus: any = TaskStatus;

    // Set while the user is being told, before anything is downloaded, that this task's report
    // belongs to an earlier baseline.
    stale_report_dialog = false;

    // The task's name as the list shows it. Tasks run on a developer's machine are marked, because
    // a development backend usually shares its database with a deployed one, so the list holds
    // both. Only the label changes: `task_name` is what loading a scenario back into the studio
    // uses, and a marker there would be submitted again as part of the name.
    // "Local" is `LOCAL_SERVICE` in transit_web/models.py.
    get display_name() {
        return this.service == "Local"
            ? "[local] " + this.task_name
            : this.task_name;
    }

    // Whether this task got as far as recording a report at all.
    get produced_report() {
        return (
            this.status == TaskStatus.Complete &&
            !("info" in this.outputs) &&
            !!this.outputs.uri
        );
    }

    // The report this task produced is no longer in the store. `report_exists` is undefined for a
    // backend that predates it and null when the store could not be read, and neither of those is
    // evidence of anything, so only an explicit false counts.
    get missing_report() {
        return this.produced_report && this.outputs.report_exists === false;
    }

    // Whether there is a report to download. Matches the conditions the download button is enabled
    // under.
    get has_report() {
        return this.produced_report && !this.missing_report;
    }

    // The baseline the task ran under, as the backend derived it from the job id
    // (`report_baseline` in `outputs`; see transit_web.models.UserTask). Undefined for a backend
    // that predates it, which is read as "no reason to warn" rather than as "out of date".
    get report_baseline_label() {
        return this.outputs.report_baseline || "an earlier baseline";
    }

    // A downloadable report that was produced against a baseline this site no longer serves. The
    // task itself is still useful -- View Scenario re-runs it against current data -- so it stays
    // in the list; it is only the report that has to carry a warning.
    get stale_report() {
        return this.has_report && this.outputs.report_is_current === false;
    }

    get download_title() {
        if (this.missing_report) return this.missing_report_note;
        if (this.stale_report) return this.stale_report_warning;
        return "Download Report";
    }

    get missing_report_note() {
        return (
            "The report this task produced is no longer in the report store. Use View Scenario to " +
            "run the same scenario again against the current baseline."
        );
    }

    get stale_report_warning() {
        return (
            "This report was produced against " +
            this.report_baseline_label +
            ", not the baseline currently being served. It does not reflect current data."
        );
    }

    get runtime() {
        var end = isNullOrUndefined(this.end_time) ? new Date() : this.end_time;
        var diffMs = end.getTime() - this.start_time.getTime(); // milliseconds between start and end
        var diffDays = Math.floor(diffMs / 86400000); // days
        var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        var diffMins = Math.floor(((diffMs % 86400000) % 3600000) / 60000); // minutes
        var diffSecs = Math.floor(
            (((diffMs % 86400000) % 3600000) % 60000) / 1000,
        ); // seconds

        var ret = "";
        if (diffDays > 0) {
            ret = ret + diffDays + " D ";
        }
        if (diffHrs > 0) {
            ret = ret + diffHrs + " h ";
        }
        if (diffMins > 0) {
            ret = ret + diffMins + " m";
        }
        if (diffSecs > 0 && diffMs < 1000 * 60 * 1) {
            // Only display seconds if the job is less than 1 mins.
            ret = ret + " " + diffSecs + " s";
        }
        return ret;
    }

    get status_color() {
        var colors = {
            [TaskStatus.Submitted]: "white",
            [TaskStatus.Complete]: "green lighten-5",
            [TaskStatus.Running]: "blue lighten-5",
            [TaskStatus.Cancelling]: "orange lighten-5",
            [TaskStatus.Cancelled]: "blue-grey lighten-5",
            [TaskStatus.Failed]: "red lighten-5",
        };
        return (colors as any)[this.status];
    }

    get status_icon() {
        var icons = {
            [TaskStatus.Submitted]: "run",
            [TaskStatus.Complete]: "check",
            [TaskStatus.Running]: "run",
            [TaskStatus.Cancelling]: "block",
            [TaskStatus.Cancelled]: "block",
            [TaskStatus.Failed]: "error_outline",
        };
        return (icons as any)[this.status];
    }

    // Remove a task from the list. The panel's own header is the click target for expanding it, so
    // this is bound with `.stop`; without that, removing a task would also toggle it open.
    onRemoveTask(e: any) {
        if (
            !window.confirm(
                `Remove "${this.display_name}" from your task list?`,
            )
        ) {
            return;
        }

        Vue.axios({
            url: endpoints.deleteTaskUrl(this.id),
            method: "DELETE",
        }).then(
            () => {
                bus.$emit("refresh_tasks", true);
            },
            (error: any) => {
                console.log(error);
                alert(
                    (error.response &&
                        error.response.data &&
                        error.response.data.detail) ||
                        "The task could not be removed. Please try again later.",
                );
            },
        );
    }

    // Cancel a task.
    onTaskCancelled(e: any) {
        console.log("Cancelling task " + this.task_name);

        Vue.axios({
            url: endpoints.cancelTaskUrl(this.execution_id),
            method: "DELETE",
        }).then(
            (response: any) => {
                console.log(response);
                bus.$emit("refresh_tasks", true);
            },
            (error: any) => {
                console.log(error);
            },
        );
    }

    // Launch a task.
    onViewScenario(e: any) {
        if (
            this.task_type == TaskType.Scenario ||
            this.task_type == TaskType.Scenario_Test
        ) {
            console.log("Loading scenario for " + this.task_name);

            var e: any = {
                task_name: this.task_name,
                inputs: this.inputs,
            };

            bus.$emit("scenario_load", e);
            bus.$emit("task_list_dialog", false);
        }
    }

    // Download the report, asking first if it belongs to an earlier baseline.
    onDownloadClicked(e: any) {
        if (this.stale_report) {
            this.stale_report_dialog = true;
        } else {
            this.onViewReport(e);
        }
    }

    // The user has been told the report is out of date and asked for it anyway.
    onConfirmStaleDownload(e: any) {
        this.stale_report_dialog = false;
        this.onViewReport(e);
    }

    // View the report.
    onViewReport(e: any) {
        Vue.axios({
            url: endpoints.viewScenarioReport(
                this.outputs.uri.split("/").pop(),
            ),
        }).then(
            (response: any) => {
                if (!isNullOrUndefined(response.data)) {
                    var signed_url: any = response.data;

                    if (signed_url == "None") {
                        //this.report_not_ready_alert = true
                        alert("Report is not ready");
                    } else {
                        (window as any).open(signed_url, "_blank");
                    }
                }
            },
            (error: any) => {
                console.log(error);

                // Anything the backend raises rather than handles comes back as a Django error
                // page, which carries no `detail` -- reading it blindly put the word "undefined"
                // in front of the user.
                alert(
                    (error.response &&
                        error.response.data &&
                        error.response.data.detail) ||
                        "The report could not be downloaded. Please try again later.",
                );
            },
        );
    }

    // View Logs.
    onViewTaskLogs(e: any) {
        (window as any).open(this.outputs.log_uri);
    }
}
